/* cstrap-khoa-folding.js — 14/10 (sep: "Single Folding dung khoa kieu Tank"). 20/10: them Double Folding + doi form Length / Lug / Clasp Width theo kieu.
   CHI chay khi section bat setting folding_tank (class cstrap--foldtank) = bespoke-watch-strap. Trang khac khong nap file nay.

   Khoa (CA HAI kieu): y template CARTIER = "Tank Deployant — Silver / Gold" (value "Deployant Clasp — Silver|Gold", +$25), tu chon Silver; khong Butterfly.
   Style of Strap = Single Folding  -> Length / Lug / Buckle Width y TEMPLATE DEPLOYANT-CLASP (Short / Long: "Up to 15 cm wrist (80 / 90 mm)" ... + Advance option)
   Style of Strap = Double Folding  -> Length / Lug / Buckle Width y TEMPLATE CARTIER ("each side": 95/95 ... 135/135 + Custom size, Lug co 17.5)
   Style khac -> tra ve danh sach KIM goc (Length / Lug y nhu cu), bo o Buckle Width; lua chon khong con hop le -> ve "Select ...".

   Nguon so: Liquid (sections/custom-strap-form.liquid) in JSON #cfold-data-<SID>: Length doc thang tu snippets/strap-size-table.liquid (qua
   snippets/strap-len-values-gap.liquid); Lug / Buckle Width chep tu form V2. Khong chep so lan 2 trong JS. Khong doi ten property giu: Length, Lug Width,
   Custom Length Long / Short, Custom Lug Width, Custom Buckle Width; them MOI property "Buckle Width" (ten y het template cartier / deployant-clasp) chi khi kieu gap. */
(function () {
  'use strict';
  var root = document.querySelector('.cstrap-section.cstrap--foldtank');
  if (!root) return;
  var SID = String(root.id || '').replace(/^cstrap-/, '');
  var radios = [].slice.call(root.querySelectorAll('input[type="radio"][name="properties[Buckle Finish]"]'));
  if (!radios.length) return;
  var isTank = function (r) { return /^Deployant Clasp/i.test(r.value); };
  var tanks = radios.filter(isTank);
  if (!tanks.length) return;
  var field = radios[0].closest('.cfield');
  var lab = field && field.querySelector('.cfield__label');
  var node = null;
  if (lab) {
    for (var i = 0; i < lab.childNodes.length; i++) {
      if (lab.childNodes[i].nodeType === 3 && /\S/.test(lab.childNodes[i].data)) { node = lab.childNodes[i]; break; }
    }
  }
  var TEN_CU = node ? node.data : '';
  /* chu hien thi rieng cho hint nhan (giong form V2 cstrap-mto-v2.js): value gio giu nguyen "Deployant Clasp — …" */
  tanks.forEach(function (r) {
    if (!r.getAttribute('data-label')) r.setAttribute('data-label', r.value.replace(/^Deployant Clasp/i, 'Tank Deployant'));
  });

  var DATA = null;
  try { DATA = JSON.parse(document.getElementById('cfold-data-' + SID).textContent); } catch (e) { DATA = null; }

  function kieuNow() {   /* '' | 'single' | 'double' */
    var s = root.querySelector('input[type="radio"][name="properties[Style of Strap]"]:checked');
    var v = s ? s.value.trim() : '';
    return /^single folding$/i.test(v) ? 'single' : /^double folding$/i.test(v) ? 'double' : '';
  }
  /* 16/10 (sep: "chon style thi no nhay ve bang buckle"): bam label -> Chrome focus radio khoa -> cuon trang xuong o khoa.
     Bam xong tra lai dung vi tri cuon + focus cu (o Style), khach van dung o cho minh vua chon. */
  function chonKhongCuon(r) {
    var x = window.scrollX, y = window.scrollY, a = document.activeElement;
    (r.closest('label') || r).click();
    var tra = function () { if (window.scrollY !== y || window.scrollX !== x) window.scrollTo(x, y); };
    tra();
    if (a && a !== document.body && a.focus) { try { a.focus({ preventScroll: true }); } catch (e) {} }
    requestAnimationFrame(tra); setTimeout(tra, 60);
  }
  function ban(x, ev) { x.dispatchEvent(new Event(ev, { bubbles: true })); }

  /* ================= FORM LENGTH / LUG / BUCKLE WIDTH THEO KIEU ================= */
  var lugSel = document.getElementById('cf-' + SID + '-lug-width');
  var lenSel = document.getElementById('cf-' + SID + '-length');
  var lugBox = document.getElementById('ccustom-lug-' + SID);
  var lenBox = document.getElementById('ccustom-len-' + SID);
  var goc = null;   /* ban chup trang thai KIM goc (chup 1 lan, truoc khi doi) */
  var cur = '';     /* kieu form dang ap: '' (KIM) | 'single' | 'double' */
  var bkF = null, bkSel = null, bkBox = null;   /* o Buckle Width them vao khi kieu gap */
  var bkLabel = null;   /* label.cnum cua o Custom Buckle Width (nam trong hop Custom Lug luc KIM) */
  var lugGocHTML = null, bangGoc = null, chuGoc = null;

  function chup() {
    if (goc || !lugSel || !lenSel) return;
    var lugSub = lugSel.closest('.cfield') && lugSel.closest('.cfield').querySelector('.cfield__sub');
    var lenSub = lenSel.closest('.cfield') && lenSel.closest('.cfield').querySelector('.cfield__sub');
    var lugDesc = lugBox && lugBox.querySelector('.cdesc'), lenDesc = lenBox && lenBox.querySelector('.cdesc');
    goc = {
      lugHTML: lugSel.innerHTML, lenHTML: lenSel.innerHTML,
      lugSub: lugSub, lugSubTxt: lugSub ? lugSub.textContent : '', lenSub: lenSub, lenSubTxt: lenSub ? lenSub.textContent : '',
      lugDesc: lugDesc, lugDescTxt: lugDesc ? lugDesc.textContent : '', lenDesc: lenDesc, lenDescTxt: lenDesc ? lenDesc.textContent : ''
    };
    bkLabel = document.getElementById('cf-bkwcustom-' + SID);
    bkLabel = bkLabel && bkLabel.closest('label.cnum');
  }

  /* "v::nhan,v2::nhan2" (cung kieu snippet cstrap-select) -> <option>; giu gia tri cu neu van con trong danh sach, khong thi ve "Select ..." */
  function datOption(sel, spec, phTxt) {
    var cu = sel.value;
    var ph = sel.querySelector('option[value=""]');
    var phChu = ph ? ph.textContent : phTxt;
    sel.innerHTML = '';
    var o0 = document.createElement('option'); o0.value = ''; o0.disabled = true; o0.textContent = phChu; sel.appendChild(o0);
    var co = false;
    String(spec).split(',').forEach(function (it) {
      var p = it.split('::'), v = p[0].trim(), l = (p[1] || p[0]).trim();
      if (!v) return;
      var o = document.createElement('option'); o.value = v; o.textContent = l; sel.appendChild(o);
      if (v === cu) co = true;
    });
    sel.value = co ? cu : '';
    if (!co) o0.selected = true;
  }
  function khoiPhucOption(sel, html) {
    var cu = sel.value;
    sel.innerHTML = html;
    var co = cu && [].some.call(sel.options, function (o) { return o.value === cu; });
    sel.value = co ? cu : '';
    if (!co) { var p = sel.querySelector('option[value=""]'); if (p) p.selected = true; }
  }

  function batChu(el, txt) { if (el) el.textContent = txt; }

  /* --- hop Custom Length: nhan + thu tu o nhap + thuoc tinh cho cstrap-size.js / engine --- */
  function lenHop(k) {
    if (!lenBox) return;
    var d = lenBox.querySelector('#cf-lencustom-' + SID), n = lenBox.querySelector('#cf-lenshort-' + SID);
    var ld = d && d.closest('label.cnum'), ln = n && n.closest('label.cnum');
    var hang = ld && ld.parentNode;
    lenBox.removeAttribute('data-hai-nua'); lenBox.removeAttribute('data-ngan-dai');
    if (!ld || !ln || !hang) return;
    var td = ld.querySelector('.cnum__t'), tn = ln.querySelector('.cnum__t');
    if (k === 'double') {          /* y template cartier = Double Folding: Side 1 / Side 2, 2 nua bang nhau */
      lenBox.setAttribute('data-hai-nua', '');
      hang.insertBefore(ld, ln); batChu(td, 'Side 1'); batChu(tn, 'Side 2');
      batChu(goc.lenDesc, 'Both sides are usually the same length.');
    } else if (k === 'single') {   /* y template deployant-clasp = Single Folding: Short truoc, Long sau */
      lenBox.setAttribute('data-ngan-dai', '');
      hang.insertBefore(ln, ld); batChu(td, 'Long'); batChu(tn, 'Short');
      batChu(goc.lenDesc, 'Short = the shorter half. Long = the longer half. Both measured to the clasp.');
    } else {                       /* KIM goc: Long truoc, Short sau */
      hang.insertBefore(ld, ln); batChu(td, 'Long'); batChu(tn, 'Short');
      batChu(goc.lenDesc, goc.lenDescTxt);
    }
    if (d) d.setAttribute('aria-label', k === 'double' ? 'Side 1 in millimetres' : 'Long end in millimetres');
    if (n) n.setAttribute('aria-label', k === 'double' ? 'Side 2 in millimetres' : 'Short end in millimetres');
  }

  /* --- o Buckle Width: them / bo --- */
  function bkThem(k) {
    var tpl = document.getElementById('cfold-bkw-' + SID);
    if (!tpl || !lugBox) return;
    if (!bkF) {
      var frag = tpl.content.cloneNode(true);
      bkF = frag.querySelector('.cfield'); bkBox = frag.querySelector('#ccustom-bkw-' + SID); bkSel = frag.querySelector('select');
      lugBox.parentNode.insertBefore(bkF, lugBox.nextSibling);
      bkF.parentNode.insertBefore(bkBox, bkF.nextSibling);
      /* chuyen o Custom Buckle Width tu hop Lug sang hop Clasp rieng (cstrap-size.js nhan ra qua #ccustom-bkw-) */
      var slot = bkBox.querySelector('[data-cfold-bkwslot]');
      if (bkLabel && slot) slot.appendChild(bkLabel);
      var bi = document.getElementById('cf-bkwcustom-' + SID); if (bi) { bi.setAttribute('aria-label', 'Clasp width in millimetres'); }
      bkSel.addEventListener('change', function () { bkCustom(); setTimeout(doBk, 30); });
      lugSel.addEventListener('change', locBk);
    }
    datOption(bkSel, DATA[k === 'double' ? 'df' : 'dc'].bk, 'Select buckle width');
  }
  function bkBo() {
    if (!bkF) return;
    lugSel.removeEventListener('change', locBk);
    var hang = lugBox && lugBox.querySelector('.cgrid2--pair');
    if (bkLabel && hang) hang.appendChild(bkLabel);   /* tra o Buckle ve hop Custom Lug (KIM) */
    var bi = document.getElementById('cf-bkwcustom-' + SID); if (bi) { bi.value = ''; bi.disabled = true; bi.required = false; bi.setAttribute('aria-label', 'Buckle width in millimetres'); }
    bkF.remove(); bkBox.remove(); bkF = bkSel = bkBox = null;
  }
  function bkCustom() {   /* y bindCustomSize cua engine: chon Custom -> hien hop nhap, bat buoc */
    if (!bkSel || !bkBox) return;
    var on = bkSel.value.slice(0, 6) === 'Custom';
    bkBox.hidden = !on;
    [].forEach.call(bkBox.querySelectorAll('input'), function (el) { el.disabled = !on; el.required = on; if (!on) el.value = ''; });
  }
  function doBk() {   /* o so Custom Buckle cung cao / font voi o select (cstrap-size.js chi do cho hop Lug / Length) */
    if (!bkSel || !bkBox || bkBox.hidden || !bkSel.getClientRects().length) return;
    var c = getComputedStyle(bkSel), h = bkSel.getBoundingClientRect().height, mb = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var co = Math.max(parseFloat(c.fontSize) || 0, mb ? 16 : 15);
    [].forEach.call(bkBox.querySelectorAll('.cnum'), function (n) {
      var st = n.style;
      st.setProperty('--cnum-h', Math.round(h) + 'px'); st.setProperty('--cnum-bw', c.borderTopWidth); st.setProperty('--cnum-bs', c.borderTopStyle); st.setProperty('--cnum-bc', c.borderTopColor);
      st.setProperty('--cnum-br', c.borderTopLeftRadius); st.setProperty('--cnum-bg', c.backgroundColor); st.setProperty('--cnum-pl', c.paddingLeft); st.setProperty('--cnum-fs', co + 'px'); st.setProperty('--cnum-ff', c.fontFamily); st.setProperty('--cnum-c', c.color);
    });
  }
  /* Clasp khong rong hon Lug (y form V2 deployant): Lug <18 -> chi 16mm (tu chon) · Lug 18/19 -> 16, 18 · Lug >=20 / Custom / trong -> het.
     Clasp dang chon khong con hop le -> xoa. Clasp do MAY tu chon ma Lug moi co >=2 lua chon -> xoa (bat khach chon). */
  var dangDat = false;
  function soMm(s) { var m = /^(\d+(?:\.\d+)?)\s*mm$/i.exec(String(s.value || '').trim()); return m ? parseFloat(m[1]) : NaN; }
  function locBk() {
    if (!bkSel) return;
    var n = soMm(lugSel), cho = isNaN(n) ? null : n < 18 ? ['16mm'] : n < 20 ? ['16mm', '18mm'] : null;
    var doi = false;
    [].forEach.call(bkSel.options, function (op) {
      if (!op.value || /^custom/i.test(op.value)) { op.disabled = !op.value; op.hidden = false; return; }
      var ok = !cho || cho.indexOf(op.value) > -1; op.disabled = !ok; op.hidden = !ok;
      if (!ok && op.selected) doi = true;
    });
    var moi = null;
    if (cho && cho.length === 1) moi = cho[0];
    else if (doi || (cho && cho.length > 1 && bkSel.__tu)) moi = '';
    if (moi !== null && bkSel.value !== moi) { dangDat = true; bkSel.value = moi; bkSel.__tu = !!moi; ban(bkSel, 'change'); dangDat = false; }
  }
  document.addEventListener('change', function (e) { if (bkSel && e.target === bkSel && !dangDat) bkSel.__tu = false; });

  /* --- popup "?" (Length guide / Lug guide) doi theo kieu --- */
  function popup(k) {
    var lb = document.getElementById('sguide-lb-' + SID);
    if (!lb) return;
    var pLen = lb.querySelector('.sguide-panel[data-guide="length"]');
    var pLug = lb.querySelector('.sguide-panel[data-guide="lug"]');
    /* bang Length: thay <table.ssize-table> bang chinh bang goc (render tu strap-size-table, nhanh deployant / butterfly) */
    if (pLen) {
      var bang = pLen.querySelector('.ssize-table');
      if (bang && !bangGoc) bangGoc = bang;
      var cuaTpl = null;
      if (k) { var t = document.getElementById('cfold-tbl-' + (k === 'double' ? 'df' : 'dc') + '-' + SID); cuaTpl = t && t.content.querySelector('.ssize-table'); }
      var hienNay = pLen.querySelector('.ssize-table');
      if (k && cuaTpl) { var nb = cuaTpl.cloneNode(true); nb.setAttribute('data-cfold', k); hienNay.replaceWith(nb); }
      else if (!k && hienNay !== bangGoc && bangGoc) hienNay.replaceWith(bangGoc);
      var pt = pLen.querySelector('.lugguide__text p'), pa = pLen.querySelector('.lugguide__after p');
      var tinh = pLen.querySelector('.ctinh'), fig = pLen.querySelector('.lugguide__fig');
      if (!chuGoc) chuGoc = { pt: pt ? pt.innerHTML : '', pa: pa ? pa.innerHTML : '' };
      if (pt) pt.innerHTML = k === 'double' ? 'A deployant strap has two <b>equal halves</b> that meet at the folding clasp under your wrist. <b>110 / 110 mm</b> means 110 mm on each side.'
        : k === 'single' ? 'A clasp strap has two parts that meet at the clasp: a <b>short</b> half and a <b>long</b> half. <b>85 / 100 mm</b> means 85 mm short, 100 mm long.' : chuGoc.pt;
      if (pa) pa.innerHTML = k === 'single' ? chuGoc.pa.replace(/<b>Custom<\/b>/, '<b>Advance option</b>') : chuGoc.pa;
      if (tinh) tinh.style.display = k === 'single' ? 'none' : '';   /* may tinh co tay khop theo dong "NN/NN mm" — bang Short/Long khac chu nen tat (y V2) */
      if (fig) fig.style.display = k === 'double' ? 'none' : '';     /* anh Long / Short khong dung cho 2 nua bang nhau */
    }
    /* Lug guide: thay NOI DUNG panel bang noi dung panel cua form V2 (deployant = cartier, butterfly = deployant-clasp).
       Giu nguyen the panel (engine giu NodeList [data-guide] luc khoi tao de bat / tat hidden). */
    if (pLug) {
      if (lugGocHTML === null) lugGocHTML = pLug.innerHTML;
      if (k) {
        var tl = document.getElementById('cfold-lug-' + (k === 'double' ? 'df' : 'dc') + '-' + SID);
        var np = tl && tl.content.querySelector('.sguide-panel[data-guide="lug"]');
        if (np) {
          [].forEach.call(tl.content.querySelectorAll('style'), function (st) {   /* CSS rieng cua panel V2, nap 1 lan */
            if (!document.getElementById('cfold-st-' + SID)) { var c = st.cloneNode(true); c.id = 'cfold-st-' + SID; document.head.appendChild(c); }
          });
          pLug.innerHTML = np.innerHTML; pLug.setAttribute('data-cfold', k);
        }
      } else { pLug.innerHTML = lugGocHTML; pLug.removeAttribute('data-cfold'); }
    }
  }

  function apForm(k) {
    if (!DATA || !lugSel || !lenSel) return;
    chup();
    if (k === cur) return;
    /* doi kieu form -> Length luon ve "Select length" (moi bang mot nghia khac); Lug ve "Select" khi KIM <-> gap (cap "20/18" khac chieu rong don "20mm"), gap <-> gap giu neu con trong danh sach */
    lenSel.value = '';
    if (!cur || !k) lugSel.value = '';
    cur = k;
    if (k) {
      var d = DATA[k === 'double' ? 'df' : 'dc'];
      datOption(lugSel, d.lug, 'Select lug width');
      datOption(lenSel, d.len, 'Select length');
      batChu(goc.lugSub, ''); batChu(goc.lenSub, k === 'double' ? '(each side)' : '(Short / Long, mm)');
      batChu(goc.lugDesc, 'Lug = gap between the lugs of your watch.');
      bkThem(k);
      /* hop Custom Lug chi con o Lug (o Buckle da sang hop rieng) */
    } else {
      bkBo();
      khoiPhucOption(lugSel, goc.lugHTML); khoiPhucOption(lenSel, goc.lenHTML);
      batChu(goc.lugSub, goc.lugSubTxt); batChu(goc.lenSub, goc.lenSubTxt); batChu(goc.lugDesc, goc.lugDescTxt);
    }
    lenHop(k);
    popup(k);
    /* ban 'change' de engine ve lai nhan hint / hop Custom / tom tat; xoa o Custom khi lua chon bi dua ve "Select ..." */
    ban(lugSel, 'change'); ban(lenSel, 'change');
    if (bkSel) { locBk(); ban(bkSel, 'change'); }
  }

  /* 20/10 (chu shop "Double dung khoa Cartier", "single cung the"): CA Single va Double Folding deu dung khoa y template CARTIER =
     "Tank Deployant — Silver / Gold" (value "Deployant Clasp — Silver|Gold", +$25 theo price_rules), tu chon Silver; khong Butterfly. Chi bang Length / Lug khac nhau. */
  var ghiChuKhoa = null;   /* dong "Fits Cartier Tank, Santos & similar." duoi o khoa (y template cartier) */
  function ap(tuChon) {
    var k = kieuNow();
    var fold = k !== '';
    root.toggleAttribute('data-khoa-folding', fold);
    if (node) node.data = fold ? TEN_CU.replace(/Buckle Finish/i, 'Tank-Style Deployant Clasp') : TEN_CU;
    if (fold && !ghiChuKhoa && field) {
      ghiChuKhoa = document.createElement('p'); ghiChuKhoa.className = 'cgon-dep-fit'; ghiChuKhoa.textContent = 'Fits Cartier Tank, Santos & similar.';
      field.appendChild(ghiChuKhoa);
    }
    if (ghiChuKhoa) ghiChuKhoa.hidden = !fold;
    var c = radios.filter(function (r) { return r.checked; })[0];
    var hopLe = !c || c.value === 'None' || (fold ? isTank(c) : !isTank(c));
    /* 14/10 (sep): khach CHON Single / Double Folding -> tu chon san khoa Tank Silver (+gia ngay); doi sang None / Tank Gold van duoc.
       Chi khi khach bam Style (tuChon) — luc tai trang khong tu chon. */
    var macDinh = fold && (tuChon || !hopLe) && (!c || !isTank(c))
      ? radios.filter(function (r) { return /silver$/i.test(r.value) && isTank(r); })[0] : null;
    if (macDinh) {
      chonKhongCuon(macDinh);
    } else if (!hopLe) {
      var none = radios.filter(function (r) { return r.value === 'None'; })[0];
      if (none) chonKhongCuon(none);
    } else if (c) {
      c.dispatchEvent(new Event('change', { bubbles: true }));   /* ve lai nhan hint (chu hien thi) */
    }
    apForm(k);
  }
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[type="radio"][name="properties[Style of Strap]"]')) ap(true);
  });
  /* luc tai trang: neu Style da chon san la Single / Double Folding thi ap luon (sau khi engine dung xong) */
  function khoiDau() { if (kieuNow()) ap(false); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', khoiDau); else khoiDau();
  setTimeout(khoiDau, 1200);
})();
